import {format} from 'date-fns';
import {CloudObject, Query, StringModel} from 'olympe';

export const utils = {};
utils.TAGS = {
    STRING: 'ff021000000000000011',
    NUMBER: 'ff021000000000000013',
    DATETIME: 'ff021000000000000014',
    BOOLEAN: 'ff021000000000000012',
    METADATA_REL: '0161ae97622bb21f335b',
    TYPE_REL: 'ff02200000000000000d',
    PROPERTY_REL: 'ff02200000000000000c',
    MODEL: 'ff022000000000000000',
    EXTEND: 'ff02200000000000000e',
    CONTAINS: 'ff02200000000000000f',
    ORIGIN_OF_RELATION_REL: 'ff02200000000000000a',
};

export const tablesAdminApp = {
    sb_group: 'SB - Groups',
    strategic_buyer_commodity: 'SB - Commodity code',
    strategic_buyer_supplier: 'SB - Supplier',
    company_code_disabling_dyn: 'DYN disabled by ComCode',
    admin_app_user_list_mapping: 'Admin App User List',
};

export const columnsAdminApp = {
    company_code: 'Company code',
    maximum_1: 'Threshold',
    maximum_1_currency: 'Currency',
    grp_name: 'Group name',
    email: 'Email',
    commodity: 'Commodity',
    total_cost: 'Total cost',
    user_mail: 'User email',
    grouping: 'Group name',
    cus_psl_vendor_status: 'Vendor status',
    supplier_id: 'Supplier code',
    name: 'Full Name',
    user_id: 'User Id',
};

/**
 * Create events usable by React component
 *
 * @param {![{name: string, event: Event, before: function(*, *)}]} events
 */
export function createEvents(events) {
    return events.reduce((acc, cur) => ({...acc, [cur.name]: (a, v) => {
        if (cur.before) cur.before(a, v); cur.event();
    }}), {});
}

/**
 * Filter an array of objects whose any properties contains a value
 * https://stackoverflow.com/questions/44312924/filter-array-of-objects-whose-any-properties-contains-a-value
 * @param {[*]} array
 * @param {string} filterText
 * @param {string} dateFormat
 * @return {*}
 */
export function filterByValue(array, filterText, dateFormat = 'YYYY-MM-DDTHH:mm:ss. sssZ') {
    return array.filter((item) => Object.keys(item).some((key) => {
        if (['id', 'tag', 'filterable'].includes(key)) {
            return false;
        }
        try {
            const searchValue = isValidDate(item[key]) ? format(item[key], dateFormat) : item[key];
            return searchValue?.toString().toLowerCase().includes(filterText.toLowerCase());
        } catch (e) {
            return false;
        }
    }));
}

/**
 * @param {*} date
 * @return {Boolean}
 */
export function isValidDate(date) {
    return date instanceof Date && !isNaN(date);
}

export function debounce(func, wait, immediate) {
    let timeout;
    return (...args) => {
        const context = this;

        const later = () => {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

/**
 * Get the column property type as defined at https://material-ui.com/components/data-grid/columns/#column-types
 *
 * @param {string} propTypeTag
 * @param {string} propName
 * @return {string}
 */
export function getMuiType(propTypeTag, propName) {
    const stringAndEnums = new Set(Query.from(StringModel)
        .followRecursively(CloudObject.extendedByRel, true)
        .executeFromCache().keys());
    switch (true) {
    case stringAndEnums.has(propTypeTag):
        return 'string';
    case propTypeTag === utils.TAGS.NUMBER:
        return 'number';
    case propTypeTag === utils.TAGS.DATETIME:
        return 'dateTime';
    case propTypeTag === utils.TAGS.BOOLEAN:
        return 'boolean';
    case propTypeTag === null:
        return 'string';
    default:
        console.warn(`Type "${propTypeTag}" from property "${propName}" is not supported.`);
        return 'string';
    }
}
